var _metadata, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Nn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 16 16",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "Made with Pixels to Svg https://codepen.io/shshaw/pen/XbxvNj")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#272727",
    d: "M2 0h4M1 1h1M6 1h1M0 2h1M7 2h1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M2 1h4M1 2h6M0 3h8M0 4h8M0 5h7M0 6h6M0 7h2M0 8h2M0 9h2M0 10h2M0 11h2M0 12h2M0 13h2M0 14h2M0 15h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#212121",
    d: "M1 15h1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Nn);
export default __webpack_public_path__ + "static/media/4nn.16d227f99ce68afcfde819caed034bba.svg";
export { ForwardRef as ReactComponent };